module.exports = __webpack_public_path__ + "img/square-a.53ed7c0c.svg";